<template>
  <!-- NOTE (TEMPLATE) to register a new proposal -->

  <div class="animated fadeIn">
    <div v-if="pageLoaded">
      <span v-show="false">{{ reactivity }}</span>
      <!-- loading component -->
      <Loading />
      <b-alert
        v-model="showTop"
        class="position-fixed fixed-top m-0 mt-9 rounded-0 bg-purple text-white text-center border-0"
        style="z-index: 2000; opacity: 60%"
        dir="rtl"
      >
        پیشنویس ثبت شد!
      </b-alert>
      <b-card
        v-if="
          $router.currentRoute.path.indexOf(
            '/researcher/completeElite/' + this.$route.params.id
          ) == 0
        "
        style="border: 0"
        class="mt-0 mb-0"
      >
        <b-card
          v-if="
            (proposal.status == 'نیاز به تکمیل / اصلاح' ||
            proposal.status == 'پیش نویس') && proposal.adminMessage
          "
          header-bg-variant="danger"
          header-text-variant="white"
          header="اصلاحات مورد نیاز"
          style="border: 0"
          class="shadow p-3 mb-5 bg-white rounded mt-0"
          >{{ proposal.adminMessage }}</b-card
        >
        <div class="d-flex justify-content-center mt-3"></div>

        <b-tabs class="mb-3" pills vertical v-model="tabIndex">
          <div class="d-flex justify-content-center mt-3">
            <!-- NOTE (b-previousTab) to go to the previous tab -->
            <b-button
              v-if="tabIndex != 0"
              class="mx-1"
              variant="light"
              @click="changePage('back')"
              >مرحله قبل</b-button
            >
            <!-- NOTE (b-saveDraft) to save draft -->
            <b-button
              :disabled="isSaving"
              class="mx-1"
              variant="success"
              @click="saveDraft()"
              >ثبت پیشنویس</b-button
            >
            <!-- NOTE (b-nextTab) to go to the next tab -->
            <b-button
              v-if="tabIndex != 6"
              class="mx-1"
              variant="primary"
              @click="changePage('next')"
              >مرحله بعد</b-button
            >
          </div>
          <b-tab :title="'حمایت های پیشین از نخبه وظیفه'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">حمایت از نخبگان وظیفه</h4>
              </template>
              <b-form-group>
                <div class="d-flex" dir="ltr">
                  <label
                    for="switch_1"
                    :class="
                      proposal.initialObligation
                        ? 'ml-3 mb-0 done'
                        : 'ml-3 mb-0 required'
                    "
                    ><h5>
                      اينجانب تعهد می‌کنم پس از احراز نخبگی توسط بنياد ملی
                      نخبگان، اقدام به تكميل اطلاعات و درخواست گذراندن طرح
                      جايگزين خدمت سربازی نموده‌ام
                    </h5></label
                  >
                  <b-form-checkbox
                    id="switch_1"
                    v-model="proposal.initialObligation"
                  ></b-form-checkbox>
                </div>
              </b-form-group>
              <hr />
              <h3 class="text-primary mb-4">پژوهشگر گرامی</h3>

              <p>
                به ابزار حمایت از مقالات سامانه تقسیم کار ملی خوش آمدید.
                خواهشندیم ابتدا به سوالات زیر پاسخ دهید:
              </p>
              <b-form-group
                label="آیا شما از حمایت‌های قبلی ستاد یا سایر نهادها استفاده کرده‌اید؟"
                :class="proposal.initialIsSupported ? 'done' : 'required'"
              >
                <b-form-radio-group v-model="proposal.initialIsSupported">
                  <b-form-radio :value="true">بله</b-form-radio>
                  <b-form-radio :value="false">خیر</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group
                label="حمایت ها:"
                v-if="proposal.initialIsSupported"
              >
                <b-form-select
                  class="myselect2"
                  id="first"
                  v-model="proposal.initialSupportedType"
                  :options="options"
                >
                </b-form-select>
              </b-form-group>
              <b-form-group
                label="عنوان حمایت دریافتی"
                v-if="
                  proposal.initialSupportedType == 'other' &&
                  !proposal.initialIsSupported
                "
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.initialOtherSupport"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                label="توضیحات حمایت دریافتی:"
                v-if="proposal.initialIsSupported"
              >
                <b-form-textarea
                  trim
                  rows="6"
                  v-model="proposal.initialSupportDescription"
                >
                </b-form-textarea>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'اطلاعات نخبه وظیفه(' + step1progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات نخبه وظیفه</h4>
              </template>
              <b-form-group
                :class="
                  proposal.researcherBachelorSubject ? 'done' : 'required'
                "
                label="عنوان پروژه کارشناسی"
              >
                <b-form-input
                  trim
                  v-model="proposal.researcherBachelorSubject"
                  required
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                :class="
                  proposal.researcherMasterThesisSubject ? 'done' : 'required'
                "
                label="عنوان پروژه کارشناسی ارشد"
              >
                <b-form-input
                  trim
                  v-model="proposal.researcherMasterThesisSubject"
                  required
                >
                </b-form-input>
              </b-form-group>
              <b-form-group label="رساله دکتری">
                <b-form-input
                  trim
                  v-model="proposal.researcherPhDThesisSubject"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                label="آخرین مدرک تحصیلی"
                :class="proposal.researcherLastDegree ? 'done' : 'required'"
              >
                <b-form-select
                  :options="lastDegree"
                  v-model="proposal.researcherLastDegree"
                  @change="resetEnc()"
                >
                </b-form-select>
              </b-form-group>

              <b-form-group
                :class="proposal.researcherResumeFile ? 'done' : 'required'"
                label="رزومه فارسی"
              >
                <b-form-file
                  :state="Boolean(proposal.researcherResumeFile)"
                  :disabled="Boolean(proposal.researcherResumeFile)"
                  @input="
                    uploadFile(uploadedFiles[0].file, 0, 'researcherResumeFile')
                  "
                  v-model="uploadedFiles[0].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[0]
                      ? files[0].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-row> </b-row>
                  <br />
                  <b-progress
                    v-if="uploadedFiles[0].uploadPercentage"
                    :value="uploadedFiles[0].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[0].striped"
                    :variant="uploadedFiles[0].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[0].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.researcherResumeFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.researcherResumeFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(0, 'researcherResumeFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                :class="proposal.researcherEliteCode ? 'done' : 'required'"
                label="کد نخبگی"
              >
                <b-form-input
                  trim
                  type="number"
                  :no-wheel="true"
                  v-model="proposal.researcherEliteCode"
                  required
                >
                </b-form-input>
              </b-form-group>
              <b-row>
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                  aria-hidden="true"
                ></i>
                <p class="mt-2 ml-2">
                  تذکر: متقاضی باید اطلاعات مورد نظر خود را در سامانه بنیاد ملی
                  نخبگان ثبت کرده و پس از احراز نخبگی کدی که به دانشگاه دفاع ملی
                  اعلام می شود را وارد کند
                </p>
              </b-row>
              <hr />
              <b-row class="mb-2">
                <b-col>
                  <span
                    :class="
                      proposal.universityId
                        ? proposal.universityId != notUniversity
                          ? 'done'
                          : proposal.otherUniversity
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                    >دانشگاه محل اجرای طرح جایگزین خدمت</span
                  >
                </b-col>
                <b-col class="text-left">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="proposal.universityId"
                    name="checkbox-1"
                    :value="notUniversity"
                    unchecked-value=""
                    @change="
                      reactivity = !reactivity;
                      proposal.mehvarId = '';
                    "
                  >
                    سایر دانشگاه ها
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-form-group>
                <Select2
                  v-model="proposal.universityId"
                  :options="universities"
                  :settings="{ width: '100%' }"
                  @change="removeMehvar()"
                  :disabled="proposal.universityId == notUniversity"
                ></Select2>

                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherUniversity"
                  v-show="proposal.universityId == notUniversity"
                  placeholder="نام دانشگاه مورد نظر"
                  @input="reactivity = !reactivity"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                :disabled="!proposal.universityId"
                label="محور طرح جایگزین خدمت (لطفا یک گزینه را انتخاب کنید)"
                :class="
                  proposal.mehvarId
                    ? proposal.mehvarId != notMehvar
                      ? 'done'
                      : proposal.otherMehvars
                      ? 'done'
                      : 'required'
                    : 'required'
                "
              >
                <b-list-group>
                  <b-list-group-item
                    style="cursor: pointer"
                    v-for="(mehvar, index) in computedMehvars"
                    :variant="selectedMehvar == index ? 'info' : 'light'"
                    :key="index"
                    @click="
                      proposal.mehvarId = mehvar.id;
                      selectedMehvar = index;
                    "
                    :disabled="mehvar.id == 0"
                  >
                    <span v-if="selectedMehvar == index">
                      <i class="fa fa-check-circle text-success"></i>
                    </span>
                    <span v-else>
                      <i class="fa fa-circle"></i>
                    </span>
                    {{ mehvar.text }}
                  </b-list-group-item>
                </b-list-group>

                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherMehvars"
                  v-show="proposal.mehvarId == notMehvar"
                  placeholder="نام محور مورد نظر"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                :class="
                  proposal.zoneMedicine ||
                  proposal.zoneAgriculture ||
                  proposal.zoneEnvironment ||
                  proposal.zoneIndustrial ||
                  proposal.zoneBioComputing ||
                  proposal.zoneOther
                    ? 'done'
                    : 'required'
                "
                label="حوزه طرح جایگزین خدمت"
              >
                <b-form-checkbox class="c-grey" v-model="proposal.zoneMedicine"
                  >پزشکی</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-grey"
                  v-model="proposal.zoneAgriculture"
                  >کشاورزی</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-grey"
                  v-model="proposal.zoneEnvironment"
                  >محیط زیست</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-grey"
                  v-model="proposal.zoneIndustrial"
                  >صنعتی</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-grey"
                  v-model="proposal.zoneBioComputing"
                  >رایانش زیستی</b-form-checkbox
                >
                <b-form-checkbox class="c-grey" v-model="proposal.zoneOther"
                  >سایر</b-form-checkbox
                >
              </b-form-group>
              <hr />
              <p
                class="text-center"
                :class="proposal.researcherMartialStatus ? 'done' : 'required'"
              >
                وضعیت تاهل
              </p>
              <b-form-radio-group
                @change="resetEnc()"
                class="text-center"
                v-model="proposal.researcherMartialStatus"
              >
                <b-form-radio value="single">مجرد</b-form-radio>
                <b-form-radio value="married">متاهل</b-form-radio>
              </b-form-radio-group>
              <div v-if="proposal.researcherMartialStatus == 'married'">
                <b-form-group class="mt-3">
                  <b-row>
                    <b-form-checkbox
                      class="ml-2"
                      dir="rtl"
                      v-model="proposal.researcherNotChildren"
                      @change="resetEnc()"
                    ></b-form-checkbox>
                    <h6 class="ml-2 mt-1">فرزند ندارم</h6>
                  </b-row>
                </b-form-group>
                <b-form-group
                  v-if="!proposal.researcherNotChildren"
                  :class="
                    Number(proposal.researcherChildrenNumber) > 0
                      ? 'done'
                      : 'required'
                  "
                  class="mt-3"
                  label="تعداد فرزند:"
                >
                  <b-form-input
                    trim
                    @change="resetEnc()"
                    v-model="proposal.researcherChildrenNumber"
                    type="number"
                    min="0"
                    :no-wheel="true"
                  ></b-form-input>
                </b-form-group>
              </div>
            </b-card>
          </b-tab>
          <b-tab :title="'مشخصات طرح جایگزین خدمت (' + step2progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">مشخصات طرح جایگزین خدمت</h4>
              </template>

              <b-form-group
                label="چکیده دوره (حداقل 100 کلمه)"
                :class="
                  proposal.abstract
                    ? proposal.abstract.split(' ').length < 100
                      ? 'required'
                      : 'done'
                    : 'required'
                "
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.abstract"
                  max-rows="6"
                ></b-form-textarea>
                طول چکیده:
                {{
                  proposal.abstract
                    ? (chek = proposal.abstract.split(" ").length)
                    : 0
                }}
                کلمه
              </b-form-group>
              <b-form-group
                label="ضرورت اجرای دوره"
                v-b-tooltip.hover.left
                title="در جهت دستیابی به اهداف ستاد و یا راهبردها و اقدامات سند توسعه زیست فناوری"
                :class="proposal.requestNecessity ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.requestNecessity"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="اهداف کلان دوره"
                :class="proposal.majorGoals ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.majorGoals"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="اهداف خرد دوره"
                :class="proposal.minorGoals ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.minorGoals"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                label="اجرای این دوره چه مزایای دیگری ممکن است برای کشور ایجاد کند؟"
                :class="proposal.benefitsToCountry ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.benefitsToCountry"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                label="روش شناسی (متدولوژی) و مراحل انجام دوره"
                :class="proposal.methodology ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.methodology"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'زمان‌بندی(' + step3progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">شرح خدمات، زمان‌بندی و فازبندی دوره</h4>
              </template>

              <b-form-group>
                <!-- NOTE (b-addService) to add a row to service items table -->
                <b-button
                  variant="success"
                  class="mb-3 ml-1"
                  @click="addService()"
                  >+</b-button
                >

                <!-- NOTE (t-serviceItems) to show informations of phase scheduling, activities description and weight percentage of activity  -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.gantData"
                  :fields="serviceFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(report)="data">
                    <b-form-checkbox
                      :id="'tooltip-target-' + data.index"
                      v-model="data.item.report"
                    ></b-form-checkbox>
                    <b-tooltip
                      placement="top"
                      :show="myshow"
                      delay="100"
                      :target="'tooltip-target-' + data.index"
                      >درصورت ارائه گزارش در پایان این فاز به ستاد، انتخاب
                      نمایید</b-tooltip
                    >
                  </template>
                  <template v-slot:cell(cellColor)="data">
                    <div>
                      <ColourPicker
                        ref="colorPicker"
                        no-input
                        picker="compact"
                        :color="data.item.cellColor"
                        :value="data.item.cellColor"
                        v-model="data.item.cellColor"
                      />
                    </div>
                  </template>

                  <template v-slot:cell(operation)="data">
                    <div>
                      <!-- NOTE (b-delService) to remove a row from service items table -->
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delService(data.index)"
                      >
                        <i class="fa fa-times" />
                      </b-button>
                    </div>
                  </template>

                  <template v-slot:cell(description)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.description"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>

                  <template v-slot:cell(percent)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.percent"
                        type="number"
                        :no-wheel="true"
                        min="0"
                        max="100"
                        :state="
                          data.item.percent > 0 && data.item.percent <= 100
                        "
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(startDate)="data">
                    <div>
                      <date-picker
                        color="#7b1fa2"
                        :auto-submit="true"
                        v-model="data.item.startDate"
                      ></date-picker>
                    </div>
                  </template>
                  <template v-slot:cell(dueDate)="data">
                    <div>
                      <date-picker
                        color="#7b1fa2"
                        :auto-submit="true"
                        v-model="data.item.dueDate"
                        :min="computedMinDate(data.item.startDate)"
                      ></date-picker>
                    </div>
                  </template>
                </b-table>

                <sarmadGantt
                  :items="proposal.gantData"
                  :fields="serviceFields"
                />

                <p
                  :class="
                    proposal.gantData.length > 0
                      ? proposal.gantData
                          .map((x) => x.percent)
                          .reduce((a, b) => Number(a) + Number(b), 0) == 100
                        ? 'done'
                        : 'required'
                      : ''
                  "
                >
                  توجه داشته باشید که مجموع درصد وزنی فعالیت باید 100 درصد باشد.
                  درصد فعلی:
                  {{
                    proposal.gantData.length == 0
                      ? 0
                      : proposal.gantData.length > 0
                      ? proposal.gantData
                          .map((x) => x.percent)
                          .reduce((a, b) => Number(a) + Number(b), 0)
                      : ""
                  }}
                  %
                </p>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'هزینه‌ها(' + step4progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">هزینه‌ها</h4>
              </template>

              <b-form-group>
                <b-row>
                  <h5 class="mt-2">
                    مبلغ حمایت:
                    <span v-if="showAmount">
                      {{
                        Number(
                          proposal.eliteFinancialSupport / 10
                        ).toLocaleString()
                      }}
                      تومان</span
                    >
                  </h5>
                  <b-button
                    class="btn mb-4 ml-3"
                    variant="primary"
                    @click="calculate()"
                    >محاسبه‌</b-button
                  >
                </b-row>
              </b-form-group>

              <b-row>
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                  aria-hidden="true"
                ></i>
                <p class="mt-2 ml-2 text-danger">
                  تذکر: به منظور محاسبه‌ی مبلغ حمایت وارد کردن اطلاعات مدرک
                  تحصیلی و وضعیت تاهل و در صورت وجود تعداد فرزند ضروری است.
                </p>
              </b-row>
            </b-card>
          </b-tab>
          <b-tab :title="'تعهدات(' + step5progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">تعهدات</h4>
              </template>

              <b-form-group>
                <b-form-checkbox
                  :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[0]"
                  >ارائه به موقع گزارش هر سه ماه یکبار در قالب فرمت
                  پیشنهادی.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[1]"
                  >بارگذرای گزارش سامانه.</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'مرور نهایی و ارسال(' + lastStepProgress + '%)'">
            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 border-0"
                role="tab"
              >
                <b-button block v-b-toggle.accordion-1 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    عنوان و حمایت‌های پیشین&nbsp;
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 0"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li
                        :class="
                          proposal.initialIsSupported ? 'done' : 'required'
                        "
                      >
                        <b
                          >آیا شما از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                          کرده‌اید؟</b
                        >
                        <b-form-radio-group
                          v-model="proposal.initialIsSupported"
                          disabled
                        >
                          <b-form-radio :value="true">بله</b-form-radio>
                          <b-form-radio :value="false">خیر</b-form-radio>
                        </b-form-radio-group>
                      </li>

                      <li
                        v-if="proposal.initialIsSupported"
                        :class="
                          proposal.initialSupportedType ? 'done' : 'required'
                        "
                      >
                        <b>حمایت ها:</b>
                        {{
                          proposal.initialSupportedType
                            ? options.filter(
                                (x) => x.value == proposal.initialSupportedType
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.initialSupportedType == 'other'"
                        :class="
                          proposal.initialOtherSupport ? 'done' : 'required'
                        "
                      >
                        <b>عنوان حمایت دریافتی:</b>
                        {{ proposal.initialOtherSupport }}
                      </li>
                      <li
                        v-if="proposal.initialIsSupported"
                        :class="
                          proposal.initialSupportDescription
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>توضیحات حمایت دریافتی:</b>
                        {{ proposal.initialSupportDescription }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 border-0"
                role="tab"
              >
                <b-button block v-b-toggle.accordion-2 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات نخبه وظیفه&nbsp;({{ step1progress }}%)
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 1"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-2"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li
                        :class="
                          proposal.researcherBachelorSubject
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>عنوان پروژه کارشناسی:</b>
                        {{ proposal.researcherBachelorSubject }}
                      </li>
                      <li
                        :class="
                          proposal.researcherMasterThesisSubject
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b> عنوان پروژه کارشناسی ارشد:</b>
                        {{ proposal.researcherMasterThesisSubject }}
                      </li>
                      <li>
                        <b>رساله دکتری:</b>
                        {{ proposal.researcherPhDThesisSubject }}
                      </li>
                      <li
                        :class="
                          proposal.researcherLastDegree ? 'done' : 'required'
                        "
                      >
                        <b>آخرین مدرک تحصیلی:</b>
                        {{ proposal.researcherLastDegree }}
                      </li>
                      <li
                        :class="
                          proposal.researcherResumeFile ? 'done' : 'required'
                        "
                      >
                        <b>رزومه فارسی:</b>
                        <a
                          v-if="proposal.researcherResumeFileId"
                          target="_blank"
                          :href="proposal.researcherResumeFile"
                          >{{ files[0].showName }}</a
                        >
                        <span v-else>--</span>
                      </li>
                      <li
                        :class="
                          proposal.researcherEliteCode ? 'done' : 'required'
                        "
                      >
                        <b>کد نخبگی:</b> {{ proposal.researcherEliteCode }}
                      </li>
                      <li :class="proposal.universityId ? 'done' : 'required'">
                        دانشگاه محل اجرای طرح جایگزین خدمت:
                        {{
                          proposal.universityId
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : "-"
                        }}
                      </li>
                      <li
                        v-if="proposal.universityId == notUniversity"
                        :class="proposal.otherUniversity ? 'done' : 'required'"
                      >
                        <b>نام دانشگاه:</b> {{ proposal.otherUniversity }}
                      </li>
                      <li
                        v-if="proposal.mehvarId != notMehvar && mehvars.length"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور طرح جایگزین خدمت:</b>
                        {{
                          proposal.mehvarId
                            ? mehvars.filter(
                                (x) => x.id == proposal.mehvarId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور طرح جایگزین خدمت:</b> سایر محورها
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.otherMehvars ? 'done' : 'required'"
                      >
                        <b>نام محور:</b> {{ proposal.otherMehvars }}
                      </li>
                      <li
                        :class="
                          proposal.zoneMedicine ||
                          proposal.zoneAgriculture ||
                          proposal.zoneEnvironment ||
                          proposal.zoneIndustrial ||
                          proposal.zoneBioComputing ||
                          proposal.zoneOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>حوزه طرح جایگزین خدمت:</b>
                        <b-form-group disabled>
                          <b-form-checkbox v-model="proposal.zoneMedicine"
                            >پزشکی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneAgriculture"
                            >کشاورزی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneEnvironment"
                            >محیط زیست</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneIndustrial"
                            >صنعتی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneBioComputing"
                            >رایانش زیستی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneOther"
                            >سایر</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                      <p
                        class="text-center"
                        :class="
                          proposal.researcherMartialStatus ? 'done' : 'required'
                        "
                      >
                        <b> وضعیت تاهل</b>
                      </p>
                      <b-form-radio-group
                        @change="resetEnc()"
                        class="text-center"
                        v-model="proposal.researcherMartialStatus"
                      >
                        <b-form-radio disabled value="single"
                          >مجرد</b-form-radio
                        >
                        <b-form-radio disabled value="married"
                          >متاهل</b-form-radio
                        >
                      </b-form-radio-group>
                      <div v-if="proposal.researcherMartialStatus == 'married'">
                        <b-form-group class="mt-3">
                          <b-row>
                            <b-form-checkbox
                              class="ml-2"
                              dir="rtl"
                              v-model="proposal.researcherNotChildren"
                              @change="resetEnc()"
                              disabled
                            ></b-form-checkbox>
                            <h6 class="ml-2 mt-1">فرزند ندارم</h6>
                          </b-row>
                        </b-form-group>
                        <b
                          :class="
                            proposal.researcherChildrenNumber
                              ? 'done'
                              : 'required'
                          "
                          >تعداد فرزند:</b
                        >
                        <b-form-group
                          v-if="!proposal.researcherNotChildren"
                          class="mt-3"
                          disabled
                        >
                          <b-form-input
                            trim
                            @change="
                              resetEnc();
                              resetFarzand();
                            "
                            v-model="proposal.researcherChildrenNumber"
                            type="number"
                            :no-wheel="true"
                            disabled
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-3 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    مشخصات طرح جایگزین خدمت&nbsp;({{ step2progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 2"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-3"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul class="p-2">
                      <li
                        class="my-2"
                        :class="proposal.abstract ? 'done' : 'required'"
                      >
                        <b>چکیده دوره:</b> {{ proposal.abstract }}
                      </li>
                      <li
                        class="my-2"
                        :class="proposal.requestNecessity ? 'done' : 'required'"
                      >
                        <b
                          >ضرورت اجرای دوره (در جهت دستیابی به اهداف ستاد و یا
                          راهبردها و اقدامات سند توسعه زیست فناوری):
                        </b>
                        {{ proposal.requestNecessity }}
                      </li>
                      <li
                        class="my-2"
                        :class="proposal.majorGoals ? 'done' : 'required'"
                      >
                        <b>اهداف کلان دوره:</b> {{ proposal.majorGoals }}
                      </li>
                      <li
                        class="my-2"
                        :class="proposal.minorGoals ? 'done' : 'required'"
                      >
                        <b>اهداف خرد دوره:</b> {{ proposal.minorGoals }}
                      </li>
                      <li
                        class="my-2"
                        :class="
                          proposal.benefitsToCountry ? 'done' : 'required'
                        "
                      >
                        <b>مزایای دیگر برای کشور:</b>
                        {{ proposal.benefitsToCountry }}
                      </li>
                      <li
                        class="my-2"
                        :class="proposal.methodology ? 'done' : 'required'"
                      >
                        <b> روش شناسی (متدولوژی) و مراحل انجام دوره:</b>
                        {{ proposal.methodology }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-4 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    زمان‌بندی&nbsp;({{ step3progress }}%)
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 3"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-4"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <p>
                    <strong class="text-primary">زمان شروع:</strong>
                    {{
                      proposal.gantData.length > 0
                        ? moment(
                            new Date(
                              Math.min(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.startDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              )
                            )
                          ).format("jYYYY/jMM/jDD")
                        : ""
                    }}
                  </p>

                  <p>
                    <strong class="text-primary">زمان پایان:</strong>
                    {{
                      proposal.gantData.length > 0
                        ? moment(
                            new Date(
                              Math.max(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              )
                            )
                          ).format("jYYYY/jMM/jDD")
                        : ""
                    }}
                  </p>
                  <p>
                    <strong class="text-primary">مدت زمان:</strong>
                    {{
                      proposal.gantData.length > 0
                        ? (Math.max(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          ) -
                            Math.min(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.startDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )) /
                            3600 /
                            24 /
                            1000 +
                          " روز"
                        : ""
                    }}
                  </p>

                  <div>
                    <sarmadGantt
                      :items="proposal.gantData"
                      :fields="serviceFields"
                    />
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-5 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    هزینه‌ها&nbsp;({{ step4progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 4"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-5"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <p>
                        <b-form-group>
                          <b-row>
                            <h5 class="mt-2">
                              مبلغ حمایت:
                              {{
                                Number(
                                  proposal.eliteFinancialSupport / 10
                                ).toLocaleString()
                              }}
                              تومان
                            </h5>
                          </b-row>
                        </b-form-group>
                      </p>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-6 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    تعهدات&nbsp;({{ step5progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 5"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-6"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <b-form-group disabled>
                      <b-form-checkbox
                        :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[0]"
                        >ارائه به موقع گزارش هر سه ماه یکبار در قالب فرمت
                        پیشنهادی.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[1]"
                        >بارگذرای گزارش سامانه.</b-form-checkbox
                      >
                    </b-form-group>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-button
              :disabled="lastStepProgress != 100"
              class="m-2"
              variant="success"
              @click="submit()"
              >ارسال</b-button
            >
            <p v-if="lastStepProgress != 100" class="required">
              به منظور ارسال دوره باید تمام مراحل را به صورت کامل (100%) پشت سر
              گذاشته باشید.
            </p>
          </b-tab>
        </b-tabs>
        <div class="d-flex justify-content-center mt-3">
          <!-- NOTE (b-previousPage-2) previous -->
          <b-button
            v-if="tabIndex != 0"
            class="mx-1"
            variant="light"
            @click="changePage('back')"
            >مرحله قبل</b-button
          >

          <!-- NOTE (b-saveDraft-2) previous -->
          <b-button
            :disabled="isSaving"
            class="mx-1"
            variant="success"
            @click="saveDraft()"
            >ثبت پیشنویس</b-button
          >

          <!-- NOTE (b-nextPage-2) previous -->
          <b-button
            v-if="tabIndex != 6"
            class="mx-1"
            variant="primary"
            @click="changePage('next')"
            >مرحله بعد</b-button
          >
        </div>
      </b-card>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import GSTC from "vue-gantt-schedule-timeline-calendar";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("../../components/sarmadGantt");
import { Compact } from "vue-color"; // REVIEW
import ColourPicker from "vue-colour-picker"; // REVIEW

export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    GSTC,
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin

    sarmadGantt: sarmadGantt,
    compact: Compact,
    ColourPicker,
  },
  data() {
    return {
      reactivity: false,
      uploadedFiles: new Array(7).fill({
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      }),
      files: [
        {
          showName: "",
          url: "",
          id: "",
        },
      ],
      max: 100,
      infoo: "",
      moment: moment,
      show: false,
      color: "",
      isSaving: false,
      busy: false,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌های تخصصی", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      taahol: ["مجرد", "متاهل بدون فرزند", "متاهل تک فرزند", "متاهل چند فرزند"],
      initial: {},
      encouragement: "",
      source: "",
      chek: "",
      specs: {},
      colleaguesData: [],
      serviceItems: [],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      promises: {},
      selectedColleague: "",
      executor: {},
      proposal: {},
      lastDegree: [
        "دکتری تخصصی",
        "دکتری عمومی",
        "کارشناسی ارشد",
        "کارشناسی و پایین‌تر",
      ],
      colleague: {},
      universities: [],
      otherUniversity: "",
      mehvars: [],
      otherMehvars: "",
      zone: new Array(6).fill(false),
      tabIndex: 1,
      support: "",
      elite: {},
      selectedMehvar: 0,
      config: {
        locale: {
          name: "en",
        },

        height: 50,
        list: {
          rows: {},
          columns: {
            data: {
              id: {
                id: "id",
                data: "id",
                width: 50,
                header: {
                  content: "ردیف",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 200,
                header: {
                  content: "نام فعالیت",
                },
              },
              start: {
                id: "start",
                data: (start) => moment(start).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ آغاز",
                },
              },
              end: {
                id: "end",
                data: (end) => moment(end).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ پایان",
                },
              },
            },
          },
        },
        chart: {
          time: {
            zoom: 12,
          },
          items: {},
        },
      },
      background: [
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
      ],
      isLoaded: true,
      showTop: false,
      pageLoaded: false,
      showAmount: false,
    };
  },

  methods: {
    removeMehvar() {
      this.proposal.mehvarId = "";
      this.proposal.otherMehvars = "";
    },
    uploadFile(file, index, fileName) {
      // NOTE to upload files
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.uploadedFiles[index].showProgress = true;
        this.uploadedFiles[index].variant = "info";
        this.uploadedFiles[index].uploadPercentage = 0;
        this.uploadedFiles[index].isUploaded = false;
        this.uploadedFiles[index].uploadButDisable = true;

        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/researcher/request/elite/upload?requestId=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.uploadedFiles[index].uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.uploadedFiles[index].isUploaded = true;
              this.uploadedFiles[index].uploadPercentage = 100;
              this.uploadedFiles[index].striped = false;
              this.uploadedFiles[index].variant = "success";
              this.uploadedFiles[index].uploadButDisable = false;
              this.proposal[fileName] = d.data.url;
              this.proposal[fileName + "Id"] = d.data.id;
              this.files[index] = d.data;
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.uploadedFiles[index].uploadPercentage = 0;
            this.uploadedFiles[index].isUploaded = false;
          });
      }
    },
    delFile(order, fileName) {
      this.uploadedFiles[order] = {
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      };
      this.files[order] = {
        showName: "",
        url: "",
        id: "",
      };
      this.proposal[fileName] = "";
      this.proposal[fileName + "Id"] = "";
    },
    resetEnc() {
      if (this.proposal.eliteFinancialSupport) {
        this.proposal.eliteFinancialSupport = 0;

        const title = (
          <div>
            <h5>تغییر مبلغ حمایت</h5>
            <span>جهت بروزرسانی مبلغ حمایت، به بخش هزینه‌ها مراجعه کنید </span>
          </div>
        );
        this.showAmount = false;
        this.toast(title, "warning");
      }
    },

    calculate() {
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/nokhbeCalculating",
          {
            degree: this.proposal.researcherLastDegree,
            martial: this.proposal.researcherMartialStatus,
            child: !this.proposal.researcherNotChildren
              ? this.proposal.researcherChildrenNumber
              : 0,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal.eliteFinancialSupport = res.data;
          this.showAmount = true;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    changePage(direction) {
      // NOTE (m-changePage) to go to the previous and next step in each step
      direction == "back" ? this.tabIndex-- : this.tabIndex++;

      // Scroll to Top
      window.scrollTo(0, 0);
      ////////////////

      // save draft !!!
      this.saveDraft();
      ////////////////
    },

    addService() {
      // NOTE (m-addService) to add service costs in the relevant sections
      this.proposal.gantData.push({
        description: "",
        percent: 0,
        startDate: moment(new Date()).format("jYYYY/jMM/jDD"),
        dueDate: moment(new Date()).add(1, "day").format("jYYYY/jMM/jDD"),
        cellColor: "blue",
      });
      const title = (
        <div>
          <h5>!فاز جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هر فاز را در جدول مربوطه تکمیل کنید و به منظور
            بروزرسانی گانت چارت روی دکمه بروزرسانی کلیک کنید
          </span>
        </div>
      );
      this.toast(title, "info");
      this.myshow = !this.myshow;
    },

    delService(order) {
      // NOTE (m-delService) to remove services in the relevant sections
      this.proposal.gantData.splice(order, 1);
    },

    computedMaxDate(dueDate) {
      // REVIEW (m-computedMaxDate)
      let m = moment(dueDate, "jYYYY/jM/jD");
      m.subtract(1, "day");

      return m.format("jYYYY/jM/jDD");
    },

    computedMinDate(startDate) {
      // REVIEW (m-computedMinDate)
      let m = moment(startDate, "jYYYY/jM/jD");
      m.add(1, "day");

      return m.format("jYYYY/jM/jDD");
    },

    saveDraft() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.showTop = true;
      // NOTE (m-saveDraft) to save drafts in each step
      this.isSaving = true;

      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/elite/draft",
          {
            requestId: this.$route.params.id,
            uploadedFiles: this.files,
            mehvarId: this.proposal.mehvarId,
            universityId: this.proposal.universityId,
            initialIsSupported: this.proposal.initialIsSupported,
            initialSupportedType: this.proposal.initialSupportedType,
            initialOtherSupport: this.proposal.initialOtherSupport,
            initialSupportDescription: this.proposal.initialSupportDescription,
            otherUniversity: this.proposal.otherUniversity,
            otherMehvars: this.proposal.otherMehvars,
            zoneMedicine: this.proposal.zoneMedicine,
            zoneAgriculture: this.proposal.zoneAgriculture,
            zoneEnvironment: this.proposal.zoneEnvironment,
            zoneIndustrial: this.proposal.zoneIndustrial,
            zoneBioComputing: this.proposal.zoneBioComputing,
            zoneOther: this.proposal.zoneOther,
            researcherBachelorSubject: this.proposal.researcherBachelorSubject,
            researcherMasterThesisSubject:
              this.proposal.researcherMasterThesisSubject,
            researcherPhDThesisSubject:
              this.proposal.researcherPhDThesisSubject,
            researcherLastDegree: this.proposal.researcherLastDegree,
            researcherEliteCode: this.proposal.researcherEliteCode,
            researcherMartialStatus: this.proposal.researcherMartialStatus,
            researcherNotChildren: this.proposal.researcherNotChildren,
            researcherChildrenNumber: this.proposal.researcherChildrenNumber,
            abstract: this.proposal.abstract,
            requestNecessity: this.proposal.requestNecessity,
            majorGoals: this.proposal.majorGoals,
            minorGoals: this.proposal.minorGoals,
            benefitsToCountry: this.proposal.benefitsToCountry,
            methodology: this.proposal.methodology,
            gantData: this.proposal.gantData,
            duration:
              this.proposal.gantData.length > 0
                ? (Math.max(
                    ...this.proposal.gantData.map((x) =>
                      new Date(
                        moment(x.dueDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
                      ).getTime()
                    )
                  ) -
                    Math.min(
                      ...this.proposal.gantData.map((x) =>
                        new Date(
                          moment(x.startDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    )) /
                  3600 /
                  24 /
                  1000
                : "0",
            // همیشه همینه. فقط دقت کنیم که متغیر جدول زمانبندی باید proposal.gantData باشد
            startDate:
              this.proposal.gantData.length > 0
                ? moment(
                    new Date(
                      Math.min(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )
                    )
                  ).format("jYYYY/jMM/jDD")
                : "",
            // همیشه همینه. فقط دقت کنیم که متغیر جدول زمانبندی باید proposal.gantData باشد
            finalDate:
              this.proposal.gantData.length > 0
                ? moment(
                    new Date(
                      Math.max(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.dueDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )
                    )
                  ).format("jYYYY/jMM/jDD")
                : "",

            eliteFinancialSupport: this.proposal.eliteFinancialSupport,
            researcherResumeFileId: this.proposal.researcherResumeFileId,
            promiseArrays: this.proposal.promiseArrays,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          setTimeout(() => {
            this.showTop = false;
          }, 1500);
          this.isSaving = false;
          // router.push("/researcher/completeProposal/" + res.data);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          setTimeout(() => {
            this.showTop = false;
          }, 1500);
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },
    submit() {
      // NOTE (m-saveDraft) to save drafts in each step
      this.isSaving = true;
      if (this.proposal.revision > 0) {
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/elite/edit",
            {
              requestId: this.$route.params.id,
              uploadedFiles: this.files,
              initialIsSupported: this.proposal.initialIsSupported,
              initialSupportedType: this.proposal.initialSupportedType,
              initialOtherSupport: this.proposal.initialOtherSupport,
              initialSupportDescription:
                this.proposal.initialSupportDescription,
              universityId: this.proposal.universityId,
              otherUniversity: this.proposal.otherUniversity,
              mehvarId: this.proposal.mehvarId,
              otherMehvars: this.proposal.otherMehvars,
              zoneMedicine: this.proposal.zoneMedicine,
              zoneAgriculture: this.proposal.zoneAgriculture,
              zoneEnvironment: this.proposal.zoneEnvironment,
              zoneIndustrial: this.proposal.zoneIndustrial,
              zoneBioComputing: this.proposal.zoneBioComputing,
              zoneOther: this.proposal.zoneOther,
              researcherBachelorSubject:
                this.proposal.researcherBachelorSubject,
              researcherMasterThesisSubject:
                this.proposal.researcherMasterThesisSubject,
              researcherPhDThesisSubject:
                this.proposal.researcherPhDThesisSubject,
              researcherLastDegree: this.proposal.researcherLastDegree,
              researcherEliteCode: this.proposal.researcherEliteCode,
              researcherMartialStatus: this.proposal.researcherMartialStatus,
              researcherNotChildren: this.proposal.researcherNotChildren,
              researcherChildrenNumber: this.proposal.researcherNotChildren
                ? "0"
                : this.proposal.researcherChildrenNumber,
              abstract: this.proposal.abstract,
              requestNecessity: this.proposal.requestNecessity,
              majorGoals: this.proposal.majorGoals,
              minorGoals: this.proposal.minorGoals,
              benefitsToCountry: this.proposal.benefitsToCountry,
              methodology: this.proposal.methodology,
              gantData: this.proposal.gantData,
              eliteFinancialSupport: this.proposal.eliteFinancialSupport,
              researcherResumeFileId: this.proposal.researcherResumeFileId,
              promiseArrays: this.proposal.promiseArrays,
              duration:
                this.proposal.gantData.length > 0
                  ? (Math.max(
                      ...this.proposal.gantData.map((x) =>
                        new Date(
                          moment(x.dueDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    ) -
                      Math.min(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )) /
                    3600 /
                    24 /
                    1000
                  : "0",
              // همیشه همینه. فقط دقت کنیم که متغیر جدول زمانبندی باید proposal.gantData باشد
              startDate:
                this.proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.min(
                          ...this.proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : "",
              // همیشه همینه. فقط دقت کنیم که متغیر جدول زمانبندی باید proposal.gantData باشد
              finalDate:
                this.proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.max(
                          ...this.proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : "",
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.toast(res.data, "success");
            this.isSaving = false;
            router.push("/researcher/elite/" + this.$route.params.id);
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.isSaving = false;
          });
      } else {
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/elite/submit",
            {
              requestId: this.$route.params.id,
              uploadedFiles: this.files,
              initialIsSupported: this.proposal.initialIsSupported,
              initialSupportedType: this.proposal.initialSupportedType,
              initialOtherSupport: this.proposal.initialOtherSupport,
              initialSupportDescription:
                this.proposal.initialSupportDescription,
              universityId: this.proposal.universityId,
              otherUniversity: this.proposal.otherUniversity,
              mehvarId: this.proposal.mehvarId,
              otherMehvars: this.proposal.otherMehvars,
              zoneMedicine: this.proposal.zoneMedicine,
              zoneAgriculture: this.proposal.zoneAgriculture,
              zoneEnvironment: this.proposal.zoneEnvironment,
              zoneIndustrial: this.proposal.zoneIndustrial,
              zoneBioComputing: this.proposal.zoneBioComputing,
              zoneOther: this.proposal.zoneOther,
              researcherBachelorSubject:
                this.proposal.researcherBachelorSubject,
              researcherMasterThesisSubject:
                this.proposal.researcherMasterThesisSubject,
              researcherPhDThesisSubject:
                this.proposal.researcherPhDThesisSubject,
              researcherLastDegree: this.proposal.researcherLastDegree,
              researcherEliteCode: this.proposal.researcherEliteCode,
              researcherMartialStatus: this.proposal.researcherMartialStatus,
              researcherNotChildren: this.proposal.researcherNotChildren,
              researcherChildrenNumber: this.proposal.researcherNotChildren
                ? "0"
                : this.proposal.researcherChildrenNumber,
              abstract: this.proposal.abstract,
              requestNecessity: this.proposal.requestNecessity,
              majorGoals: this.proposal.majorGoals,
              minorGoals: this.proposal.minorGoals,
              benefitsToCountry: this.proposal.benefitsToCountry,
              methodology: this.proposal.methodology,
              gantData: this.proposal.gantData,
              eliteFinancialSupport: this.proposal.eliteFinancialSupport,
              researcherResumeFileId: this.proposal.researcherResumeFileId,
              promiseArrays: this.proposal.promiseArrays,
              duration:
                this.proposal.gantData.length > 0
                  ? (Math.max(
                      ...this.proposal.gantData.map((x) =>
                        new Date(
                          moment(x.dueDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    ) -
                      Math.min(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )) /
                    3600 /
                    24 /
                    1000
                  : "0",
              // همیشه همینه. فقط دقت کنیم که متغیر جدول زمانبندی باید proposal.gantData باشد
              startDate:
                this.proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.min(
                          ...this.proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : "",
              // همیشه همینه. فقط دقت کنیم که متغیر جدول زمانبندی باید proposal.gantData باشد
              finalDate:
                this.proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.max(
                          ...this.proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : "",
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.toast(res.data, "success");
            this.isSaving = false;
            router.push("/researcher/elite/" + this.$route.params.id);
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.isSaving = false;
          });
      }
    },
    onMounted() {
      this.uploadedFiles = JSON.parse(JSON.stringify(this.uploadedFiles));
      this.files = JSON.parse(JSON.stringify(this.files));
      let acc = 0;
      // NOTE (MOUNTED) to show the profile of user

      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/elite/getInfo",
          {
            requestId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal = res.data;
          this.files = res.data.uploadedFiles;
          //----------------------------------
          //// this.additionalFiles = JSON.parse(res.data.project.files);
          //this.proposal.gantData.forEach((x, index) => {
          //  this.config.list.rows[JSON.stringify(index + 1)] = new Object({
          //    id: JSON.stringify(index + 1),
          //    label: x.description,
          //  });

          //  this.config.chart.items[JSON.stringify(index + 1)] = new Object({
          //    id: JSON.stringify(index + 1),
          //    rowId: JSON.stringify(index + 1),
          //    label: x.description,
          //    time: {
          //      start: new Date(
          //        moment(x.startDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
          //      ).getTime(),
          //      end: new Date(
          //        moment(x.dueDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
          //      ).getTime(),
          //    },
          //    style: {
          //      background: this.background[index],
          //    },
          //  });
          //});
          this.fileBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });

      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
          this.$bvModal.hide("loading");
          this.isLoaded = true;

          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          // this.mehvars.push(
          //   new Object({
          //     id: 1,
          //     text: "سایر محورها",
          //     universityId: 1
          //   })
          // );
          this.pageLoaded = true;
          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
  computed: {
    step1progress() {
      let progress = 0;
      let total = 9;
      this.proposal.researcherBachelorSubject ? progress++ : 1;
      this.proposal.researcherMasterThesisSubject ? progress++ : 1;
      this.proposal.researcherEliteCode ? progress++ : 1;
      this.proposal.researcherLastDegree ? progress++ : 1;

      if (this.proposal.mehvarId && this.proposal.mehvarId != 1) {
        progress++;
      } else {
        if (this.proposal.mehvarId == 1) {
          if (this.proposal.otherMehvars) {
            progress++;
          }
        }
      }
      if (this.proposal.universityId) {
        if (this.proposal.universityId != 1) {
          progress++;
        } else {
          if (
            this.proposal.universityId == 1 &&
            this.proposal.otherUniversity
          ) {
            progress++;
          }
        }
      }
      this.proposal.researcherResumeFile ? progress++ : 1;

      this.proposal.zoneMedicine ||
      this.proposal.zoneAgriculture ||
      this.proposal.zoneEnvironment ||
      this.proposal.zoneIndustrial ||
      this.proposal.zoneBioComputing ||
      this.proposal.zoneOther
        ? progress++
        : 1;
      if (this.proposal.researcherMartialStatus) {
        if (this.proposal.researcherMartialStatus == "single") {
          progress++;
        } else {
          if (this.proposal.researcherNotChildren) {
            progress++;
          } else if (Number(this.proposal.researcherChildrenNumber) > 0) {
            progress++;
          }
        }
      }

      progress = parseInt((progress / total) * 100);
      return progress;
    },
    step2progress() {
      let progress = 0;

      this.chek >= 100 ? progress++ : 1;
      this.proposal.requestNecessity ? progress++ : 1;
      this.proposal.majorGoals ? progress++ : 1;
      this.proposal.minorGoals ? progress++ : 1;
      this.proposal.benefitsToCountry ? progress++ : 1;
      this.proposal.methodology ? progress++ : 1;

      progress = parseInt((progress / 6) * 100);
      return progress;
    },

    step3progress() {
      let progress = 0;
      let total = 1;
      if (this.proposal.gantData) {
        if (this.proposal.gantData.length == 0) return 0;
      }
      if (this.proposal.gantData) {
        total += this.proposal.gantData.length * 4;
      }

      try {
        if (this.proposal.gantData.length > 0) {
          this.proposal.gantData.forEach((x) => {
            x.description ? progress++ : 1;
            x.percent == 0 || x.percent ? progress++ : 1;
            x.startDate ? progress++ : 1;
            x.dueDate ? progress++ : 1;
          });

          this.proposal.gantData
            .map((x) => x.percent)
            .reduce((a, b) => Number(a) + Number(b), 0) == 100
            ? progress++
            : 1;
        }
      } catch (error) {}

      progress = parseInt((progress / total) * 100);
      return progress;
    },

    step4progress() {
      let progress = 0;

      this.proposal.eliteFinancialSupport > 0 ? progress++ : 1;

      progress = parseInt((progress / 1) * 100);
      return progress;
    },

    step5progress() {
      // NOTE (c-step10Progress) previous
      let progress = 0;
      for (let i = 0; i <= 1; i++) {
        this.proposal.promiseArrays[i] ? progress++ : 1;
      }
      return parseInt((progress / 2) * 100);
    },
    lastStepProgress() {
      // NOTE (c-lastStepProgress) previous
      let wholeSteps = 0;
      for (let i = 1; i <= 5; i++) {
        wholeSteps += this["step" + i + "progress"];
      }
      // x => (wholeSteps += this["step" + x + "progress"])

      return parseInt(wholeSteps / 5);
    },
    computedMehvars() {
      // NOTE (c-computedMehvars) to after selecting university show to user list of mehvars of selected university
      let mehvarha = [];
      if (this.proposal.universityId) {
        mehvarha = this.mehvars.filter(
          (x) => x.universityId == this.proposal.universityId
        );
        if (this.proposal.universityId != this.notUniversity) {
          this.proposal.mehvarId = this.proposal.mehvarId;
        } else if (this.proposal.universityId == this.notUniversity) {
          this.proposal.mehvarId = this.notMehvar;
        }
      }

      if (this.proposal.universityId) {
        mehvarha.push(
          new Object({
            id: this.notMehvar,
            text: "سایر محورها",
            universityId: this.proposal.universityId,
          })
        );
      } else {
        mehvarha.push(
          new Object({
            id: 0,
            text: "لطفا ابتدا یک دانشگاه انتخاب کنید",
            universityId: this.proposal.universityId,
          })
        );
      }
      if (this.proposal.mehvarId)
        this.selectedMehvar = mehvarha.findIndex(
          (x) => x.id == this.proposal.mehvarId
        );
      else this.selectedMehvar = "-";
      // alert(mehvarha.map(y=>y.id))
      // this.proposal.mehvarId ? this.selectedMehvar = mehvarha.map(y=>y.id).findIndexOf(this.proposal.mehvarId) : this.selectedMehvar = ''
      return mehvarha;
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.onMounted();
  },
};
</script>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
